<template>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="section mt-1">
        <div class="tab-container-1">
            <nav class="pill-tabs" aria-label="Member Categories">
                <button class="pill-tab" :class="{ active: wing == 1 }" @click="getMembersList(1)" type="button">
                    Wisdom {{ unit.wisdom_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 2 }" @click="getMembersList(2)" type="button">
                    Youth {{ unit.youth_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 3 }" @click="getMembersList(3)" type="button">
                    Students {{ unit.students_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 4 }" @click="getMembersList(4)" type="button">
                    Women {{ unit.women_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 5 }" @click="getMembersList(5)" type="button">
                    Balavedi {{ unit.balavedi_count }}
                </button>
                <button class="pill-tab" :class="{ active: wing == 6 }" @click="getMembersList(6)" type="button">
                    Girls {{ unit.girls_count }}
                </button>
            </nav>
        </div>
    </div>

    <!-- Payment Modal -->
    <div class="modal fade action-sheet" id="paymentModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Payment Details</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="submitPayment" :validation-schema="paymentSchema">
                            <div class="form-group basic">
                                <label class="label">Payment Method</label>
                                <Field as="select" class="form-control custom-select" v-model="paymentMethod" 
                                       name="paymentMethod">
                                    <option value="">Select Payment Method</option>
                                    <option value="cash">Cash</option>
                                    <option value="bank_transfer">Bank Transfer</option>
                                    <option value="upi">UPI</option>
                                    <option value="card">Card</option>
                                </Field>
                                <ErrorMessage name="paymentMethod" class="error-feedback" />
                            </div>

                            <div class="form-group basic" v-if="paymentMethod && paymentMethod !== 'cash'">
                                <label class="label">Transaction Reference</label>
                                <Field name="transactionRef" type="text" class="form-control" 
                                       v-model="transactionRef" placeholder="Enter transaction reference" />
                                <ErrorMessage name="transactionRef" class="error-feedback" />
                            </div>

                            <div class="form-group basic">
                                <label class="label">Payment Date</label>
                                <Field name="paymentDate" type="date" class="form-control" 
                                       v-model="paymentDate" />
                                <ErrorMessage name="paymentDate" class="error-feedback" />
                            </div>

                            <div class="form-group basic">
                                <label class="label">Notes</label>
                                <Field name="notes" as="textarea" class="form-control" 
                                       v-model="paymentNotes" placeholder="Optional notes" rows="3" />
                            </div>

                            <div class="payment-summary-modal">
                                <h6>Payment Summary</h6>
                                <div class="d-flex justify-content-between">
                                    <span>Selected Members:</span>
                                    <strong>{{ selectedMembersCount }}</strong>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <span>Total Amount:</span>
                                    <strong class="text-success">₹{{ totalPaymentAmount }}</strong>
                                </div>
                            </div>

                            <div class="form-group" v-if="paymentMessage">
                                <div class="error-feedback">{{ paymentMessage }}</div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-success btn-block btn-lg" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm me-2"></span>
                                    Confirm Payment
                                </button>
                                <button type="button" class="btn btn-secondary btn-block btn-lg mt-2" 
                                        @click="closePaymentModal">
                                    Cancel
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" placeholder="ഇവിടെ സെർച്ച് ചെയ്യുക..." v-model="search_qty"
                @input="filteredMembers()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>

    <!-- Select All Controls -->
    <div class="section mt-2" v-if="!loading_list && member_lists.length">
        <div class="select-all-controls">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" 
                       :checked="allMembersSelected" 
                       @change="toggleSelectAll()" 
                       id="selectAllMembers">
                <label class="form-check-label" for="selectAllMembers">
                    Select All Available Members
                </label>
            </div>
            
            <!-- Total Amount Display -->
            <div class="total-amount-display" v-if="selectedMembersCount > 0">
                <div class="amount-info">
                    <span class="amount-label">Selected {{ selectedMembersCount }} member{{ selectedMembersCount > 1 ? 's' : '' }}</span>
                    <span class="amount-value">₹{{ totalPaymentAmount }}</span>
                </div>
                
                <!-- Payment Link -->
                <div class="payment-link-section">
                    <a :href="'https://guide.msoftit.com/payment?gway=payu&bulk=1&user_id=' + currentUser.id + '&member_id=' + selectedMembersString">
                        <button class="btn btn-payment">
                            <ion-icon name="card-outline"></ion-icon>
                            Make Payment
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <ul class="listview image-listview inset text mt-0 mb-2" v-if="!loading_list && member_lists.length">
        <li v-for="(member_list, index) in member_lists" v-bind:key="member_list.id"
            :set="background = member_list.payment_status === 'Paid' ? 'rgb(200 247 197)' : (selectedMembers.includes(member_list.id) ? 'rgb(255 243 205)' : '#ffffff')"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item">
                
                <!-- Payment Checkbox - only show if not paid and not renewed -->
                <div class="payment-checkbox" v-if="member_list.payment_status !== 'Paid' && !member_list.not_renewed">
                    <input type="checkbox" :id="'payment_' + member_list.id" 
                           :value="member_list.id" v-model="selectedMembers"
                           @change="updatePaymentTotal">
                    <label :for="'payment_' + member_list.id" class="checkbox-label">
                        <ion-icon name="checkmark-outline"></ion-icon>
                    </label>
                </div>

                <span class="sl-no">{{ index + 1 }}</span>
                
                <div class="avatar-section">
                    <a href="#">
                        <img v-if="member_list.avatar != 'member.jpg' && member_list.avatar != null"
                            :src="'https://guide.msoftit.com/' + member_list.avatar" alt="avatar" class="image">
                        <img v-if="!member_list.avatar || member_list.avatar == 'member.jpg'"
                            :src="'assets/img/sample/avatar/avatar1.png'" alt="avatar" class="image">
                        
                        <!-- Payment Status Badge -->
                        <span class="button payment-paid" v-if="member_list.payment_status === 'Paid'">
                            <ion-icon name="card-outline"></ion-icon>
                        </span>
                        <span class="button payment-pending" v-else>
                            <ion-icon name="time-outline"></ion-icon>
                        </span>
                    </a>
                </div>
                
                <div class="in">
                    <div class="member-details">
                        <b>{{ member_list.name }}</b>
                        <footer>
                            {{ member_list.country_code }} {{ member_list.mobile }}
                            <br>
                            <!-- Payment Information -->
                            <div class="payment-info">
                                <span class="payment-amount" v-if="member_list.membership_fees">
                                    <strong>Fee: ₹{{ member_list.membership_fees }}</strong>
                                </span>
                                <span class="payment-status-text" 
                                      :class="member_list.payment_status === 'Paid' ? 'text-success' : 'text-warning'">
                                    {{ member_list.payment_status === 'Paid' ? 'Payment Completed' : 'Payment Pending' }}
                                </span>
                                <span v-if="member_list.payment_date && member_list.payment_status === 'Paid'" 
                                      class="payment-date">
                                    Paid on: {{ formatDate(member_list.payment_date) }}
                                </span>
                            </div>
                        </footer>
                    </div>
                    
                    <!-- <div class="payment-actions">
                        <button type="button" class="btn btn-sm btn-outline-primary" 
                                @click="viewPaymentHistory(member_list)" v-if="member_list.payment_status === 'Paid'">
                            <ion-icon name="receipt-outline"></ion-icon>
                        </button>
                    </div> -->
                </div>
            </a>
        </li>
    </ul>

    <!-- Payment History Modal -->
    <div class="modal fade action-sheet" id="paymentHistoryModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Payment History</h5>
                </div>
                <div class="modal-body">
                    <div v-if="selectedMemberPayments.length">
                        <div v-for="payment in selectedMemberPayments" :key="payment.id" 
                             class="payment-history-item">
                            <div class="d-flex justify-content-between">
                                <span>Amount:</span>
                                <strong>₹{{ payment.amount }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                                <span>Method:</span>
                                <span>{{ payment.method }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <span>Date:</span>
                                <span>{{ formatDate(payment.date) }}</span>
                            </div>
                            <div v-if="payment.transaction_ref" class="d-flex justify-content-between">
                                <span>Reference:</span>
                                <span>{{ payment.transaction_ref }}</span>
                            </div>
                            <hr>
                        </div>
                    </div>
                    <div v-else>
                        <p>No payment history found.</p>
                    </div>
                    <button type="button" class="btn btn-secondary btn-block" @click="closePaymentHistoryModal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: 'MembersListPayment',
    props: {
        unit_id: null,
        permissions: Object
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel
    },
    data() {
        const paymentSchema = yup.object().shape({
            paymentMethod: yup.string().required("Payment method is required"),
            paymentDate: yup.string().required("Payment date is required"),
            transactionRef: yup.string().when('paymentMethod', {
                is: (val) => val && val !== 'cash',
                then: (schema) => schema.required("Transaction reference is required for non-cash payments"),
                otherwise: (schema) => schema.notRequired()
            })
        });

        return {
            loading: false,
            loading_list: false,
            member_lists: [],
            orgnal_member_lists: [],
            unit: [],
            search_qty: '',
            wing: 1,
            
            // Payment specific data
            selectedMembers: [],
            selectedMembersCount: 0,
            totalPaymentAmount: 0,
            paymentMethod: '',
            transactionRef: '',
            paymentDate: '',
            paymentNotes: '',
            paymentMessage: '',
            paymentSchema,
            selectedMemberPayments: [],
            
            // Alert
            alert_type: '',
            alert_message: ''
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        hasSelectedMembers() {
            return this.selectedMembers.length > 0;
        },
        allMembersSelected() {
            const unpaidMembers = this.member_lists.filter(member => 
                member.payment_status !== 'Paid' && !member.not_renewed
            );
            return unpaidMembers.length > 0 && this.selectedMembers.length === unpaidMembers.length;
        },
        selectedMembersString() {
            return this.selectedMembers.join(',');
        }
    },
    watch: {
        selectedMembers: {
            handler() {
                this.updatePaymentTotal();
            },
            deep: true
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.getMembersList(1);
            this.setDefaultPaymentDate();
        }
    },
    methods: {
        getMembersList(wing) {
            this.loading_list = true;
            this.selectedMembers = []; // Clear selections when switching wings
            this.updatePaymentTotal();
            
            let data = {
                unit_id: this.unit_id ? this.unit_id : this.currentUser.unit_id,
                wing: wing,
                include_payment_status: true // Add flag to include payment information
            }
            
            UserService.authPostRequest('get-members', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_lists = response.data.data.list;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list;
                        this.unit = response.data.data.unit;
                        this.wing = wing;
                        this.loading_list = false;
                    } else {
                        this.loading_list = false;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.handleError(error);
                }
            );
        },

        updatePaymentTotal() {
            this.selectedMembersCount = this.selectedMembers.length;
            this.totalPaymentAmount = 0;
            
            this.selectedMembers.forEach(memberId => {
                const member = this.member_lists.find(m => m.id === memberId);
                if (member && member.membership_fees) {
                    this.totalPaymentAmount += parseFloat(member.membership_fees);
                }
            });
        },

        toggleSelectAll() {
            const unpaidMembers = this.member_lists.filter(member => 
                member.payment_status !== 'Paid' && !member.not_renewed
            );
            
            if (this.allMembersSelected) {
                this.selectedMembers = [];
            } else {
                this.selectedMembers = unpaidMembers.map(member => member.id);
            }
            this.updatePaymentTotal();
        },

        processPayment() {
            if (this.selectedMembers.length === 0) {
                this.showAlert('Warning', 'Please select at least one member for payment');
                return;
            }
            $('#paymentModal').modal('show');
        },

        setDefaultPaymentDate() {
            const today = new Date();
            this.paymentDate = today.toISOString().split('T')[0];
        },

        submitPayment() {
            this.loading = true;
            this.paymentMessage = '';

            const paymentData = {
                member_ids: this.selectedMembers,
                payment_method: this.paymentMethod,
                transaction_ref: this.transactionRef,
                payment_date: this.paymentDate,
                notes: this.paymentNotes,
                total_amount: this.totalPaymentAmount,
                unit_id: this.unit_id ? this.unit_id : this.currentUser.unit_id
            };

            UserService.authPostRequest('process-membership-payment', paymentData).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.closePaymentModal();
                        this.showAlert('Success', response.data.message);
                        this.getMembersList(this.wing); // Refresh the list
                        this.selectedMembers = [];
                        this.updatePaymentTotal();
                    } else {
                        this.paymentMessage = response.data.message;
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.paymentMessage = this.handleError(error);
                }
            );
        },

        closePaymentModal() {
            $('#paymentModal').modal('hide');
            this.resetPaymentForm();
        },

        resetPaymentForm() {
            this.paymentMethod = '';
            this.transactionRef = '';
            this.paymentNotes = '';
            this.paymentMessage = '';
            this.setDefaultPaymentDate();
        },

        viewPaymentHistory(member) {
            const data = {
                member_id: member.id
            };

            UserService.authPostRequest('get-member-payment-history', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.selectedMemberPayments = response.data.data.payments;
                        $('#paymentHistoryModal').modal('show');
                    } else {
                        this.showAlert('Warning', 'No payment history found');
                    }
                },
                (error) => {
                    this.handleError(error);
                }
            );
        },

        closePaymentHistoryModal() {
            $('#paymentHistoryModal').modal('hide');
            this.selectedMemberPayments = [];
        },

        filteredMembers() {
            this.loading_list = true;
            let filter_list = this.orgnal_member_lists;

            filter_list = filter_list.filter((member) => {
                return this.search_qty.toLowerCase().split(' ').every(v => 
                    member.name.toLowerCase().includes(v) || 
                    member.mobile.toLowerCase().includes(v)
                );
            });

            this.member_lists = filter_list;
            this.loading_list = false;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN');
        },

        showAlert(type, message) {
            this.alert_type = type;
            this.alert_message = message;
            this.$refs.alert_model.openModel();
        },

        handleError(error) {
            const message = (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            this.showAlert('Error', message);
            return message;
        }
    }
};
</script>

<style scoped>
.error-feedback {
    color: red;
}

.payment-summary {
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 15px;
    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
}

.payment-summary-content {
    margin-bottom: 15px;
}

.payment-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.payment-info-row:last-child {
    margin-bottom: 0;
}

.payment-label {
    font-size: 16px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
}

.payment-value {
    font-size: 18px;
    font-weight: bold;
    color: white;
}

.payment-value.total-amount {
    font-size: 24px;
    color: #fff;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.select-all-controls {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 15px;
    text-align: center;
}

.total-amount-display {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #e9ecef;
}

.amount-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
}

.amount-label {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
}

.amount-value {
    font-size: 20px;
    font-weight: bold;
    color: white;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.payment-link-section {
    margin-top: 15px;
    text-align: center;
}

.payment-link-section a {
    text-decoration: none;
}

.btn-payment {
    background: linear-gradient(135deg, #007bff, #0056b3);
    border: none;
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 3px 10px rgba(0, 123, 255, 0.3);
    min-width: 160px;
    justify-content: center;
}

.btn-payment:hover {
    background: linear-gradient(135deg, #0056b3, #004085);
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(0, 123, 255, 0.4);
}

.btn-payment ion-icon {
    font-size: 18px;
}

.payment-checkbox {
    display: flex;
    align-items: center;
    margin-right: 10px;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
}

.payment-checkbox input[type="checkbox"] {
    display: none;
}

.checkbox-label {
    width: 24px;
    height: 24px;
    border: 2px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.payment-checkbox input[type="checkbox"]:checked + .checkbox-label {
    background-color: #28a745;
    border-color: #28a745;
    color: white;
}

.avatar-section .button.payment-paid {
    background: #28a745;
}

.avatar-section .button.payment-pending {
    background: #ffc107;
    color: #212529;
}

.payment-info {
    margin-top: 5px;
}

.payment-amount {
    display: block;
    font-weight: 600;
    color: #2c5aa0;
    margin-bottom: 2px;
}

.payment-status-text {
    display: block;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 2px;
}

.payment-date {
    display: block;
    font-size: 11px;
    color: #666;
}

.member-details {
    flex: 1;
}

.payment-actions {
    display: flex;
    align-items: center;
    gap: 5px;
}

.payment-summary-modal {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
}

.payment-history-item {
    padding: 10px 0;
}

.payment-history-item:last-child hr {
    display: none;
}

.listview > li {
    transition: background-color 0.3s ease;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
    margin-left: 30px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 10px 10px;
}

.tab-container-1 {
    display: flex;
    justify-content: center;
    margin: 1.5rem 0 1rem 0;
}

.pill-tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    max-width: 600px;
    margin: 0 auto;
}

.pill-tab {
    flex: 1 1 140px;
    min-width: 120px;
    max-width: 200px;
    padding: 0.6rem 1rem;
    border: none;
    border-radius: 999px;
    background: #f5f7fa;
    color: #1a418c;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.18s, color.18s, box-shadow 0.18s;
    outline: none;
    box-shadow: 0 1px 3px rgba(26, 65, 140, 0.04);
    margin: 0;
    text-align: center;
    white-space: nowrap;
}

.pill-tab.active,
.pill-tab:focus {
    background: #1a418c;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(26, 65, 140, 0.10);
}

.form-check {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    justify-content: center;
}

.form-check-input {
    margin: 0;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.form-check-label {
    margin: 0;
    font-weight: 600;
    color: #1a418c;
    cursor: pointer;
    font-size: 16px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.image-listview.text > li:after {
    left: 0px;
    background-color: #1a418c;
}

/* Custom button styles for payment */
.btn-success {
    background: linear-gradient(135deg, #28a745, #20c997);
    border: none;
}

.btn-success:hover {
    background: linear-gradient(135deg, #218838, #1ea97c);
}

@media (max-width: 800px) {
    .pill-tabs {
        max-width: 100%;
        gap: 0.7rem;
    }

    .pill-tab {
        flex: 1 1 110px;
        font-size: 0.98rem;
        padding: 0.5rem 0.7rem;
    }
    
    .payment-summary {
        padding: 15px;
    }
    
    .amount-value {
        font-size: 18px;
    }
    
    .amount-info {
        padding: 10px 14px;
    }
    
    .btn-payment {
        padding: 10px 20px;
        font-size: 15px;
        min-width: 140px;
    }
}

@media (max-width: 500px) {
    .pill-tabs {
        gap: 0.5rem;
    }

    .pill-tab {
        flex: 1 1 90px;
        font-size: 0.95rem;
        padding: 0.45rem 0.5rem;
    }
    
    .payment-summary {
        padding: 12px;
    }
    
    .amount-label {
        font-size: 13px;
    }
    
    .amount-value {
        font-size: 16px;
    }
    
    .amount-info {
        padding: 8px 12px;
    }
    
    .select-all-controls {
        padding: 12px;
    }
    
    .btn-payment {
        padding: 8px 16px;
        font-size: 14px;
        min-width: 120px;
    }
    
    .payment-link-section {
        margin-top: 12px;
    }
}
</style>